var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortcutComponent",
      attrs: { modalClass: "lm-modal", showBtnOk: false },
    },
    [
      _c(
        "div",
        { attrs: { slot: "component" }, slot: "component" },
        [
          _c("grid-component", {
            attrs: {
              data: _vm.gridData,
              columns: _vm.gridColumn,
              showEditItem: false,
              showRemoveItem: false,
              showActionColumn: false,
              showAddNewButton: false,
              showTableFoot: false,
              showTools: false,
              showTableHead: false,
              selectableLine: true,
            },
            on: { "selected-line": _vm.onSelectRecompensa },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }